module.exports = __webpack_public_path__ + "img/Successful-Google-Cloud-Migration-1440x564_c 1.62132f1.svg";